import { configureStore, ThunkAction, Action  } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice.js"
import widgetsReducer from "./slices/widgetsSlice.js";
import connectorReducer from "./slices/connectorSlice.js";
import roleUserReducer from "./slices/roleUserSlice.js";
import formEditorReducer from "./slices/formEditorSlice.js"
import masterDataReducer from "./slices/masterDataSlice.js"
import userRoleGroupReducer from "./slices/userRoleGroupSlice.js";
import companyReducer from "./slices/companySlice.js";
import planReducer from "./slices/planSlice.js";


const store = configureStore({
    reducer: {
        user: userReducer,
        widgets: widgetsReducer,
        connector: connectorReducer,
        roleUser: roleUserReducer,  
        formEditor: formEditorReducer,
        masterData: masterDataReducer,
        userRoleGroupState: userRoleGroupReducer,
        company: companyReducer,
        plan: planReducer
    }
});
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>

export default store;